import { InjectionToken } from '@angular/core';
import { enumHtsChatScope } from '@data-layer/enums/common';

/**
 * Which hts-chat read endpoints a host page uses. Provided as `Broker` by the customs-broker form injector;
 * hosts inject it optionally and fall back to `Importer`.
 */
export const HTS_CHAT_SCOPE: InjectionToken<enumHtsChatScope> = new InjectionToken<enumHtsChatScope>('HTS_CHAT_SCOPE');
